const CRAZY_EGG_SCRIPT_URL = 'https://script.crazyegg.com/pages/scripts/0132/8221.js';

const isCrazyEggEnabled = () => import.meta.env.VITE_ENV === 'production';

let lastIdentifiedEmail: string | null = null;

export const initCrazyEgg = () => {
  if (!isCrazyEggEnabled()) {
    return;
  }

  if (document.querySelector(`script[src="${CRAZY_EGG_SCRIPT_URL}"]`)) {
    return;
  }

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = CRAZY_EGG_SCRIPT_URL;
  script.async = true;
  document.head.appendChild(script);
};

/**
 * Ties the current Crazy Egg session (recording, heatmap, A/B variant) to a user, so the
 * "Trial Started" conversions Stripe sends can be matched back to it. Crazy Egg matches on
 * the literal string, so this must be the same email Stripe Checkout receives -- the backend
 * prefills the Checkout Session with the organization owner's email (see
 * `BillingSubscriptionService.createCheckoutSession`).
 *
 * `CE2.identify()` is a no-op while the session isn't being recorded; the conversion still
 * lands in the Conversions report, it just isn't attached to a recording.
 */
export const identifyCrazyEggUser = (email: string) => {
  if (!isCrazyEggEnabled() || !email || email === lastIdentifiedEmail) {
    return;
  }

  lastIdentifiedEmail = email;

  const queue = (window.CE_API = window.CE_API || []);

  queue.push(() => {
    if (typeof window.CE2?.identify === 'function') {
      window.CE2.identify(email);
    }
  });
};

/** Clears the memo above so the next signed-in user is identified again. */
export const resetCrazyEggIdentity = () => {
  lastIdentifiedEmail = null;
};
